import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import {
  SITE_URL,
  SITE_NAME,
  DEFAULT_OG_IMAGE,
  organizationSchema,
  localBusinessSchema,
  websiteSchema,
  webPageSchema,
} from "@/lib/seo";

const stringify = (obj) => JSON.stringify(obj).replace(/</g, "\\u003c");

export default function Seo({
  title,
  description,
  image,
  keywords,
  type = "website",
  noindex = false,
  schemas = [],
  breadcrumbs,
}) {
  const { pathname } = useLocation();
  const url = `${SITE_URL}${pathname === "/" ? "" : pathname}`;
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const ogImage = image || DEFAULT_OG_IMAGE;

  const pageSchema = webPageSchema({
    url,
    title: fullTitle,
    description,
    breadcrumbs,
  });

  const allSchemas = [
    organizationSchema(),
    localBusinessSchema(),
    websiteSchema(),
    pageSchema,
    ...schemas,
  ];

  return (
    <Helmet>
      <html lang="en-GB" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"}
      />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <script type="application/ld+json">{stringify(allSchemas)}</script>
    </Helmet>
  );
}
